// extracted by mini-css-extract-plugin
export var alternate = "_16-h";
export var black = "_16-3";
export var blue = "_16-d";
export var blueLight = "_16-c";
export var brand = "_16-7";
export var error = "_16-9";
export var gray = "_16-6";
export var grayBlue = "_16-b";
export var iconWrapper = "_16-4";
export var indigo = "_16-e";
export var orange = "_16-g";
export var pink = "_16-f";
export var primary = "_16-0";
export var purple = "_16-8";
export var success = "_16-5";
export var warning = "_16-a";
export var white = "_16-1";
export var whiteSuccess = "_16-2";